

const LandingPage = () => {

    return (
        <div className="container text-center">
            <p>
                An app for tracking your <b>Competitive Programming Practice</b>!
            </p>
        </div>
    )
}

export default LandingPage